import { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Button from '../Button'

import b1 from "../../img/Home/back.svg";
import b2 from "../../img/Home/next.svg";

import sw1 from '../../img/Accounts/a1.svg';
import sw2 from '../../img/Accounts/a2.svg';
import sw3 from '../../img/Accounts/a3.svg';
import sw4 from '../../img/Accounts/a4.svg';

import no from '../../img/Accounts/no.svg';
import yes from '../../img/Accounts/yes.svg';
import yes2 from '../../img/Accounts/yes2.svg'

const data = [
  {
    img: sw1,
    title: "Access 250",
    minDeposit: "250 USD",
    accountCurrency: "USD",
    leverage: "Forex",
    spread: "-",
    commission: "-",
    swapFree: "+",
    maxOrders: "+",
    marginCall: "1-2%",
    bg: '#FFFFFF',
  },
  {
    img: sw2,
    title: "Privilege 1500",
    minDeposit: "1500 USD",
    accountCurrency: "USD",
    leverage: "Forex, Commodity",
    spread: "-",
    commission: "+",
    swapFree: "+",
    maxOrders: "+",
    marginCall: "1%",
    bg: '#A3A3A3',
  },
  {
    img: sw3,
    title: "Excellency 10000",
    minDeposit: "10000 USD",
    accountCurrency: "USD",
    leverage: "Forex, Commodity, Stocks, Cryptocurrency",
    spread: "+",
    commission: "+",
    swapFree: "+",
    maxOrders: "+",
    marginCall: "0.5%",
    bg: '#1E1C21',
  }
];

function Main() {

  const { t } = useTranslation();
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const paginationRef = useRef(null);
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current && paginationRef.current) {
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();

      swiperInstance.params.pagination.el = paginationRef.current;
      swiperInstance.pagination.init();
      swiperInstance.pagination.update();
    }
  }, [swiperInstance]);

  return (
    <div className="relative z-50 pt-[40px] xl:pt-[60px] overflow-hidden">
      <div className="max-w-[1220px] relative xl:mx-auto mx-[20px]">
        <div className="flex flex-col xl:flex-row justify-between">
          <p className="xl:max-w-[605px] zen-dots leading-[1.2] text-[24px] xl:text-[36px] text-[#1E1C21]">
            {t("account.1")}
          </p>
          <p className="xl:max-w-[600px] text-[#000000B2] text-[14px] ibm-plex mt-[20px]">
            {t("account.2")}
          </p>
        </div>
        <div className="flex flex-col xl:flex-row justify-between mt-[40px] xl:mt-[80px]">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            loop={false}
            autoplay={{ delay: 3000 }}
            navigation={{
              prevEl: '.custom-prev',
              nextEl: '.custom-next',
            }}
            pagination={{
              el: '.custom-pagination',
              clickable: true,
            }}
            className="w-full h-full"
            spaceBetween={20}
            breakpoints={{
              0: {
                slidesPerView: 1, // телефон
              },
              640: {
                slidesPerView: 2, // планшет
              },
              1220: {
                slidesPerView: 3, // ПК
              },
            }}
          >
            {data.map((item, index) => (
              <SwiperSlide key={index}>
                <div className={`h-[620px] py-[20px] px-[20px] xl:pl-[40px] flex flex-col`} style={{background: item.bg}}>
                    <div className="flex items-center gap-[10px] xl:gap-[30px]">
                      <div style={{background: index === 2 ? '#FE7320' : '#1E1C21'}} className="w-[60px] h-[60px] flex items-center justify-center">
                        <img src={item.img} alt="" className="w-[22px] h-[22px]"/>
                      </div>
                      <h2 className="zen-dots text-[16px] xl:text-[24px] mt-[5px]" style={{color: index === 2 ? '#FE7320' : '#1E1C21'}}>{t(item.title)}</h2>
                    </div>
                    <div className="grid grid-cols-2 mt-[25px] gap-y-[8px]">
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{t('account.7')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{data[index].minDeposit}</p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{t('account.8')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{data[index].accountCurrency}</p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{t('account.9')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{data[index].leverage}</p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{t('account.10')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}>
                        {data[index].spread === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].spread === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].commission
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}>
                        {t('account.11')}
                      </p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}>
                        {data[index].commission === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].commission === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].commission
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}>
                        {t('account.12')}
                      </p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}>
                        {data[index].swapFree === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].swapFree === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].swapFree
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{t('account.13')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}>
                        {data[index].maxOrders === '-' ? (
                          <img src={no} alt="No" className="w-4 h-4 inline-block" />
                        ) : data[index].maxOrders === '+' ? (
                          <img src={index === 2 ? yes2 : yes} alt="Yes" className="w-4 h-4 inline-block" />
                        ) : (
                          data[index].commission
                        )}
                      </p>
                      <p className="ibm-plex text-[14px]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{t('account.14')}</p>
                      <p className="ibm-plex text-[14px] font-[500]" style={{color: index === 2 ? '#FFFFFFB2' : '#000000B2'}}>{data[index].marginCall}</p>
                      {index === 3 && (
                        <>
                          <p
                            className="ibm-plex text-[14px]"
                            style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}
                          >
                            {t('account.19')}
                          </p>
                          <p
                            className="ibm-plex text-[14px] font-[500]"
                            style={{ color: index === 2 ? '#FFFFFFB2' : '#000000B2' }}
                          >
                            {data[index].execution}
                          </p>
                        </>
                      )}
                    </div>
                    
                </div>  
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="flex flex-col-reverse xl:hidden xl:flex-row justify-between mt-[10px] xl:mt-0 w-full md:w-auto">
          <div className="flex items-center justify-between border-[#00000033] h-[48px] md:w-auto w-full">
            <div className="flex md:w-auto w-full">
                <button ref={prevRef} className="w-full custom-prev md:w-[124px] border-l border-t bg-white border-b hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b1} alt="" /></button>
                <button ref={nextRef} className="w-full custom-next md:w-[124px] border bg-white hover:border hover:border-black transition-all h-[48px] border-[#00000033] flex items-center justify-center cursor-my"><img src={b2} alt="" /></button>
            </div>
          </div>
        </div>
        <div className="bg-white xl:h-[428px] w-full py-[20px] px-[20px] xl:px-[40px] mt-[10px] xl:mt-[20px]">
          <div className="flex items-center gap-[10px] xl:gap-[30px]">
            <div className="w-[60px] h-[60px] bg-[#1E1C21] flex items-center justify-center">
              <img src={sw4} alt="" className="w-[22px] h-[22px]"/>
            </div>
            <h2 className="zen-dots text-[16px] xl:text-[24px] mt-[5px] text-[#1E1C21]">Islamic Account</h2>
          </div>
          <div className="flex flex-col md:flex-row justify-between gap-[20px] mt-[15px] xl:mt-[25px]">
            <div>
              <div className="grid grid-cols-2 gap-x-[30px] gap-y-[8px]">
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('account.7')}</p>
                <p className="ibm-plex text-[14px] font-[500] text-[#000000B2]">1000 USD</p>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('account.8')}</p>
                <p className="ibm-plex text-[14px] font-[500] text-[#000000B2]">USD</p>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('account.14')}</p>
                <p className="ibm-plex text-[14px] font-[500] text-[#000000B2]">From 0.8%</p>
              </div>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px] xl:mt-[40px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.1')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.2')}</p>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.3')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.3.3')}</p>
            </div> 
            <div className="mt-[20px] xl:mt-0">
              <div className="flex gap-[8px] xl:gap-[16px] items-center">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.4')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.5')}</p>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.6')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.7')}</p>
              <div className="flex gap-[8px] xl:gap-[16px] items-center mt-[20px]">
                <div className="w-[4px] h-[4px] bg-[#1E1C21] flex-shrink-0"></div>
                <p className="ibm-plex text-[14px] text-[#000000B2]">{t('acc.10')}</p>
              </div>
              <p className="max-w-[550px] font-[500] text-[14px] ibm-plex text-[#000000B2] mt-[5px]">{t('acc.11')}</p>
            </div>
          </div>
        </div>
        <div className="flex flex-col-reverse xl:flex-row justify-between mt-[10px] xl:mt-[60px] w-full md:w-auto">
          <div className="mt-[40px] xl:mt-0">
            <p className="xl:max-w-[703px] text-[#000000B2] text-[12px] ibm-plex">
              {t("account.17")}
            </p>
            <p className="xl:max-w-[703px] text-[#000000B2] text-[12px] ibm-plex mt-[15px]">
              {t("account.18")}
            </p>
          </div>
          
        </div>
        
      </div>
    </div>
  );
}

export default Main;
